import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const StressPage = lazy(() => import("./StressPage.tsx"));

const StressPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <StressPage />
    </Suspense>
  );
};

export default StressPageLazy;
